import { httpRequest } from '@/utils/request';
import { CommonResponse, TableReponseType } from '@/types';

// 设备固件相关接口类型定义
export interface DeviceFirmware {
  id: number;
  product_id: string; // 产品ID
  firmware_name: string; // 固件包名称
  firmware_description: string; // 固件描述
  firmware_version: number; // 固件版本
  firmware_download_url: string; // 固件下载地址
  device_id_whitelist: string; // 设备ID白名单
  device_id_blacklist: string; // 设备ID黑名单
  extension_params: string; // 扩展参数
  is_enabled: number; // 是否启用 0-禁用 1-启用
  created: number; // 创建时间戳
  modified: number; // 修改时间戳
}

export interface DeviceFirmwareAddRequest {
  firmware_name: string;
  firmware_version: number;
  product_id: number;
  firmware_description: string;
  firmware_download_url: string;
  device_id_blacklist?: string;
  device_id_whitelist?: string;
  extension_params?: string;
  is_enabled: number;
}

export interface DeviceFirmwareUpdateRequest extends DeviceFirmwareAddRequest {
  id: number;
}

export interface DeviceFirmwareListParams {
  page?: number;
  pageSize?: number;
  firmwareName?: string; // 固件包名称搜索
  productId?: number; // 产品ID筛选
  isEnabled?: number; // 启用状态筛选
}

// 获取设备固件列表
export const getDeviceFirmwareList = (params: DeviceFirmwareListParams) => {
  return httpRequest<any, CommonResponse<TableReponseType<DeviceFirmware>>>({
    url: '/api/v1/device-firmwares',
    method: 'GET',
    params,
  });
};

// 获取设备固件详情
export const getDeviceFirmwareDetail = (firmwareId: number) => {
  return httpRequest<any, CommonResponse<DeviceFirmware>>({
    url: `/api/v1/device-firmware/${firmwareId}`,
    method: 'GET',
  });
};

// 添加设备固件
export const addDeviceFirmware = (data: DeviceFirmwareAddRequest) => {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-firmware',
    method: 'POST',
    data,
  });
};

// 更新设备固件
export const updateDeviceFirmware = (data: DeviceFirmwareUpdateRequest) => {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-firmware',
    method: 'PUT',
    data,
  });
};

// 删除设备固件
export const deleteDeviceFirmware = (firmwareId: number) => {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device-firmware/${firmwareId}`,
    method: 'DELETE',
  });
};
